'use client';

import type { FC, ReactNode } from 'react';
import { FaCheckCircle } from '@/components/icons';
import { cn } from '@/utils/cn';

export const authButtonClass = 'h-[46px] rounded-xl text-base leading-6 tracking-normal font-semibold';

interface AuthScreenShellProps {
  icon?: ReactNode;
  linked?: boolean;
  title?: string;
  description?: string;
  maxWidth?: 320 | 420;
  align?: 'center' | 'stretch';
  error?: ReactNode;
  children?: ReactNode;
}

export const AuthScreenShell: FC<AuthScreenShellProps> = ({
  icon,
  linked = false,
  title,
  description,
  maxWidth = 320,
  align = 'center',
  error,
  children,
}) => (
  <div className="w-full h-full flex items-center justify-center px-5 text-white">
    <div
      className={cn(
        'w-full flex flex-col gap-3',
        maxWidth === 420 ? 'max-w-[420px]' : 'max-w-[320px]',
        align === 'center' && 'items-center text-center',
      )}
    >
      {icon &&
        (linked ? (
          <div className="relative mb-2">
            {icon}
            <FaCheckCircle size={20} className="text-accent-green absolute -bottom-1 -end-1" />
          </div>
        ) : (
          icon
        ))}
      {title && <h1 className="text-2xl font-bold text-white">{title}</h1>}
      {description && <p className="text-sm text-white/60 mb-4">{description}</p>}
      {children}
      {error && <p className={cn('text-accent-red text-sm mt-2', align !== 'center' && 'text-center')}>{error}</p>}
    </div>
  </div>
);
